export type InferedAnnotation = any;

export enum InferedAnnotationActionEnum {
  setInferedAnnotation = 'SET_INFERED_ANNOTATION'
}

export type InferedAnnotationAction = {
  type: InferedAnnotationActionEnum.setInferedAnnotation;
  payload: InferedAnnotation;
};
